import './instrument';
import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import Cookies from 'js-cookie';
import Hotjar from '@hotjar/browser';
import { FetchContext } from 'src/lib/FetchContext';
import { HeadContextProvider } from 'src/lib/HeadContext';
import { SocketContextProvider } from 'src/lib/SocketContext';
import { SsrInitDataContext } from 'src/lib/SsrInitDataContext';
import { importPolyfills } from 'src/lib/polyfills/polyfills';
import { createBrowserContext, PrefetchProfilingContextProvider } from 'src/lib/usePrefetch';
import { App } from './App';
import { sendHotjarIdentify } from './lib/hotjarUtils';


if(HOTJAR_SITE_ID) {
  Hotjar.init(HOTJAR_SITE_ID, 6);

  setTimeout(() => {
    sendHotjarIdentify({ isLoggedIn: Cookies.get('RIAC_RESTKEY') ? true : false });
  }, 1000);
}

window.reportClientError = (message) => {
  const code = Math.round(Math.random() * 10000);
  window.fetch('/api/errorlog/submit', {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      message: message.message || message,
      code,
      stack: message.stack,
    }),
  });
  return code;
};
(async () => {
  await importPolyfills();
  const BrowserDataContext = createBrowserContext();

  const AppJSX = (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <PrefetchProfilingContextProvider mark={() => {}}>
      <BrowserDataContext>
        <FetchContext.Provider
          value={{ fetch: async (input, init) => {
            if(!init) {
              init = {};
            }
            init = Object.assign({}, init, {
              credentials: 'include',
            });
            const results = await fetch(input, init);
            // If we get a 401, we need to try refreshing the access token
            // This doesn't do that yet. It just makes a new one.
            if(results.status === 401) {
              const response = await fetch('/oauth2/refresh', {
                credentials: 'include',
              });
              if(response.ok) {
                const data = await response.json();
                if(data.success) {
                  return await fetch(input, init);
                }
              }
            }
            return results;
          } }}
        >
          <SsrInitDataContext.Provider
            value={{
              ssr: false,
              serverCompactMode: undefined,
              skipMaintenance: undefined,
              hasLoginToken: undefined,
              location: undefined,
            }}
          >
            <HeadContextProvider value={{ isHead: false }}>
              <SocketContextProvider>
                <App/>
              </SocketContextProvider>
            </HeadContextProvider>
          </SsrInitDataContext.Provider>
        </FetchContext.Provider>
      </BrowserDataContext>
    </PrefetchProfilingContextProvider>
  );
  if(window.serverSideRenderingError) {
    console.log('ssr error');
    ReactDOMClient.createRoot(document.getElementById('react-root')).render(AppJSX);
  } else {
    ReactDOMClient.hydrateRoot(document.getElementById('react-root'), AppJSX);
  }
})();
